module.exports = __webpack_public_path__ + "Flag-203.ec4e50ddf7c77dcecf90f96bb7eab171.svg";